<template>
  <div></div>
</template>

<script>
import utils from '@/utils';

export default {
  name: 'Application',
  mounted() {
    this.$store.dispatch('app/changeSys', utils.SYS_KEYS[1]);
    this.$store.dispatch('tagsView/delAllViews');
    this.$nextTick(() => {
      this.$router.push(`/${this.$route.params.user_id}${utils.COMMUNITY_INDEX_PATH}`);
    });
    this.$destroy('Application');
  }
};
</script>
